// Captures Google's OAuth callback parameters into memory and strips them from
// the address bar before any app module, analytics or third-party asset loads.
// Imported by recoveryHandoff.ts BEFORE the shared Supabase client module, so
// it runs before any auth URL detection. Must never import the Supabase client.
// The one-time code never touches storage.
import { GOOGLE_G1_CALLBACK_PATH } from '@/config/googleDriveG1';

export interface GoogleCallbackParams {
  code: string | null;
  state: string | null;
  error: string | null;
}

let captured: GoogleCallbackParams | null = null;

export function captureGoogleCallback(loc: Location = window.location, hist: History = window.history): void {
  if (loc.pathname !== GOOGLE_G1_CALLBACK_PATH || !loc.search) return;
  const p = new URLSearchParams(loc.search);
  captured = { code: p.get('code'), state: p.get('state'), error: p.get('error') };
  try { hist.replaceState(null, '', loc.pathname); } catch { /* ignore */ }
}

/** Returns the captured params once; later calls get null (no double use). */
export function takeGoogleCallback(): GoogleCallbackParams | null {
  const c = captured;
  captured = null;
  return c;
}

if (typeof window !== 'undefined') captureGoogleCallback();
